import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import type { AuthEmailChangeModalProps, Panel } from './type'

import { Dialog } from '@/components/ui'

import { CompletePanel } from './CompletePanel'
import { FormPanel } from './FormPanel'

export const AuthEmailChangeModal = ({
  defaultValues,
  isOpen,
  onClose,
}: AuthEmailChangeModalProps) => {
  const { t } = useTranslation()
  const [currentPanel, setCurrentPanel] = useState<Panel>('form')

  const handleComplete = () => {
    setCurrentPanel('form')
    onClose()
  }

  const handleSubmitted = () => {
    setCurrentPanel('complete')
  }

  return (
    <Dialog title={t('auth.email.title')} isOpen={isOpen}>
      {currentPanel === 'form' ? (
        <FormPanel
          defaultValues={defaultValues}
          onSubmit={handleSubmitted}
          onClose={onClose}
        />
      ) : (
        <CompletePanel onClose={handleComplete} />
      )}
    </Dialog>
  )
}
